













































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { TextoEditavel } from '../../../../back/src/entity/TextoEditavel';

export default Vue.extend({
  name: 'TextosEditaveisAlterar',
  components: {
  },
  data() {
    return {
      textoEditavel: Object as () => TextoEditavel,
      form: {
        nome: '',
        texto: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    textoEditavelId(): number {
      return Number(this.$route.params.textoEditavelId);
    },
    formTextoEditavel(): Vue & { validate: () => boolean } {
      return this.$refs.formTextoEditavel as Vue & { validate: () => boolean };
    },
  },
  mounted() {
    this.getTextoEditavel();
  },
  methods: {
    async getTextoEditavel(): Promise<void> {
      try {
        const response = await Requester.textoEditavel.textoEditavel(this.textoEditavelId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.textoEditavel = response.data;
          this.form.nome = this.textoEditavel.nome;
          this.form.texto = this.textoEditavel.texto;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm(): Promise<void> {
      const formData: TextoEditavel = {
        id: this.textoEditavelId,
        nome: this.form.nome,
        texto: this.form.texto,
      };
      if (this.formTextoEditavel.validate()) {
        try {
          const response = await Requester.textoEditavel.alteraTextoEditavel(formData);
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          } else {
            this.$root.$emit('avisoSnackbar', { color: 'success', text: ['Dados salvos.'] });
            this.$router.push({ name: 'TextosEditaveisIndex' });
          }
        } catch (err) {
          this.$root.$emit('requestError', err);
        } finally {
          this.loading = false;
        }
      }
    },
  },
});
